/* stack.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./stack.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Children } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
var listStyles = null;
var listSmallStyles = null;
var listItemStyles = null;
var listItemSmallStyles = null;
var Stack = function Stack(_ref) {
  var id = _ref.id,
    children = _ref.children,
    testId = _ref.testId,
    label = _ref['aria-label'],
    size = _ref.size;
  return /*#__PURE__*/React.createElement("ul", {
    id: id,
    "data-testid": testId,
    "aria-label": label,
    className: ax(["_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t", size === 'small' && fg('platform-avatar-group-spacing-fix') && "_12l21b66"])
  }, Children.map(children, function (child) {
    return child && /*#__PURE__*/React.createElement("li", {
      className: ax(["_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t", size === 'small' && fg('platform-avatar-group-spacing-fix') && "_12l2r5cr"])
    }, child);
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Stack;